import React from 'react';
import { useTranslation } from 'react-i18next';
import { renderSlackMrkdwn, renderTemplatePreview } from './slackMrkdwn';

interface TemplatePreviewProps {
  /** Message body to preview; placeholders are substituted with samples. */
  body: string;
  /** Overrides for the sample placeholder values, e.g. `{ years: '5' }`. */
  previewParams?: Record<string, string>;
  testId: string;
}

/**
 * Bordered Slack-style preview of a message body, falling back to the empty
 * hint when the body is blank.
 */
export const TemplatePreview: React.FC<TemplatePreviewProps> = ({
  body,
  previewParams,
  testId,
}) => {
  const { t } = useTranslation('admin');

  return (
    <div
      className="rounded-md border border-prosigliere-grey bg-muted/50 p-3 text-sm whitespace-pre-wrap break-words"
      data-testid={testId}
    >
      {body.trim() ? (
        renderSlackMrkdwn(renderTemplatePreview(body, previewParams))
      ) : (
        <span className="text-muted-foreground">{t('notificationTemplates.previewEmpty')}</span>
      )}
    </div>
  );
};
